import { createFileRoute } from "@tanstack/react-router";
import { SignUpPage } from "@/features/auth/SignUpPage";
import { z } from "zod";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/auth/signup")({
  validateSearch: searchSchema,
  component: SignUpPage,
});
